import React from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function FactCard({ fact, index, total }) {
  return (
    <div className="relative w-full max-w-4xl mx-auto" data-testid="fact-card-wrap">
      <AnimatePresence mode="wait">
        <motion.article
          key={fact?.id || "empty"}
          initial={{ opacity: 0, y: 24, scale: 0.97 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: -16, scale: 1.02 }}
          transition={{ type: "spring", damping: 24, stiffness: 220 }}
          className="bg-[#ffffff] fact-card-shadow border border-[#e8eae3] rounded-[28px] p-8 md:p-14 lg:p-16 min-h-[44vh] flex flex-col justify-between"
          data-testid="fact-card"
        >
          <div className="flex items-center justify-between">
            <span className="label-eyebrow" data-testid="fact-index">
              Bilgi · {String(index + 1).padStart(2, "0")} / {String(total).padStart(2, "0")}
            </span>
            <div className="h-px flex-1 mx-6 bg-[#e8eae3]" />
            <span className="font-mono-key text-[10px] tracking-widest text-[#a3aba6]">
              SIRA · {String(fact?.order ?? 0).padStart(2, "0")}
            </span>
          </div>

          <p
            className="font-serif-fact text-[#1c2723] text-2xl md:text-3xl lg:text-[2.45rem] leading-[1.35] my-10 md:my-14 text-left"
            data-testid="fact-text"
          >
            {fact?.text}
          </p>

          <div className="flex items-center justify-between">
            <div className="label-eyebrow text-[#a3aba6]">
              Yavaşça okuyun — sonra karara varın
            </div>
            <div className="hidden md:flex items-center gap-2 label-eyebrow text-[#a3aba6]">
              <span>boşluk · öğrendim</span>
            </div>
          </div>
        </motion.article>
      </AnimatePresence>
    </div>
  );
}
